import { z } from 'zod';

/**
 * ISO 8601 timestamp string, UTC.
 * Wire format for all time values; DB uses `timestamptz`.
 */
export const IsoTimestampSchema = z.string().datetime({ offset: true }).brand<'IsoTimestamp'>();
export type IsoTimestamp = z.infer<typeof IsoTimestampSchema>;

/**
 * Common audit fields present on every record.
 * Tables extend this with their own fields.
 */
export const AuditFieldsSchema = z.object({
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
  createdBy: z.string().uuid().nullable().optional(),
  updatedBy: z.string().uuid().nullable().optional(),
  deletedAt: IsoTimestampSchema.nullable(),
});
export type AuditFields = z.infer<typeof AuditFieldsSchema>;
